export const ROUTES = {
  HOME: '/',
  DASHBOARD: '/dashboard',
  REGISTER: '/register',
  REGISTER_PERSONAL: '/register/personal',
  REGISTER_MEDICAL: '/register/medical',
  SUCCESS: '/success',
  QR: '/qr',
  ADMIN: '/admin',
  AUDIT_LOGS: '/audit-logs',
};

export const getRegisterUrl = () => {
  // Returns the absolute URL for the patient registration form (personal details step)
  // Using window.location.origin to construct a full URL suitable for QR codes.
  return `${window.location.origin}${ROUTES.REGISTER_PERSONAL}`;
};
